<template>
  <div style="padding:5px;">
    <h6>Информация пользователя</h6>

    <b v-if="this.$store.state.user != null">{{ this.$store.state.user.name }}</b>
    
    <br>

    <b v-if="this.$store.state.user != null">{{ this.$store.state.user.email }}</b>
  </div>
</template>

<script>
export default {
  name: "DefaultAside"
};
</script>
